import React from 'react';
import { ShoppingBagIcon, FileTextIcon, SyringeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const ACTIONS = [{
  title: 'Shop Over-The-Counter',
  icon: <ShoppingBagIcon className="w-6 h-6" data-id="element-152" />,
  link: '/otc-products'
}, {
  title: 'Transfer Your Prescription',
  icon: <FileTextIcon className="w-6 h-6" data-id="element-153" />,
  link: '/prescriptions'
}, {
  title: 'Check Vaccine Availability',
  icon: <SyringeIcon className="w-6 h-6" data-id="element-154" />,
  link: '/services'
}];
export function QuickActions() {
  return <section className="py-12 sm:py-16 bg-clean-grey" data-id="element-155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <h2 className="text-lg sm:text-xl font-bold text-slate-900 mb-8 sm:mb-10 text-center uppercase tracking-widest" data-id="element-157">
          What would you like to do today?
        </h2>
        <div className="grid md:grid-cols-3 gap-4 sm:gap-6" data-id="element-158">
          {ACTIONS.map((action, idx) => <Link key={idx} to={action.link} className="bg-white p-6 sm:p-10 rounded-xl border border-slate-200 flex flex-col items-center text-center hover:shadow-md transition-shadow cursor-pointer group" data-id="element-159">
              <div className="text-clinical-blue mb-4 sm:mb-6 group-hover:scale-110 transition-transform" data-id="element-160">
                {action.icon}
              </div>
              <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wide" data-id="element-161">
                {action.title}
              </h3>
            </Link>)}
        </div>
      </div>
    </section>;
}